import { render, staticRenderFns } from "./OpcionPlantillaPersonalizada.vue?vue&type=template&id=034dfab6"
import script from "./OpcionPlantillaPersonalizada.vue?vue&type=script&lang=js"
export * from "./OpcionPlantillaPersonalizada.vue?vue&type=script&lang=js"
import style0 from "./OpcionPlantillaPersonalizada.vue?vue&type=style&index=0&id=034dfab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VRadio,VRadioGroup,VSelect})
